/**
 * NotifyTypeFunc 枚举
 */
export var NotifyTypeFunc = {
  set: 1,
  get: 2
};
/**
 * NotifyTypeFunc 枚举
 */
export var NotifyType = {
  none: 0,
  allNotify: 1,
  relatedToMe: 2
};
/**
 * GetNotifyType 请求数据结构
 */

/**
 * SetNotifyType 请求数据结构
 */

/**
 * EditNotify 请求数据结构
 */

/**
 * GetNotifyType 返回数据结构
 */

/**
 * SetNotifyType 返回数据结构
 */

/**
 * 拉取notifyType成功后的事件
 */

/**
 * 用户信息聚合
 */
//# sourceMappingURL=aggregate.js.map